<script>
import PrizePool from "@/components/2025/Prizes/PrizePool.vue";
import SectionTitle from "@/components/2025/SectionTitle/SectionTitle.vue";
import TournamentQualifierCard from "@/components/2025/Cards/TournamentQualifierCard.vue";
import TimeLine from "@/components/2025/TimeLine/TimeLine.vue";
import LgameParticipatePopUp from "@/components/LgameParticipatePopUp.vue";

export default {
  name: "FreeFireTournament",
  components: {LgameParticipatePopUp, TimeLine, TournamentQualifierCard, SectionTitle, PrizePool},
  data(){
    return {
      tournaments_qualis: {
        1: process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI1_ID,
        2: process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI2_ID,
        3: process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI3_ID,
      },
      showPopUp: false,
      popUpOptions: {
        type: '',
        title: '',
        message: '',
      },
    }
  },
  methods:{
    acceptAction(payload) {
      this.showPopUp = false;
      if (payload && payload.hasCustomFields) {
        if (payload.teamId) {
          this.$store.dispatch('subTournaments/registerTeamIn', {
            teamId: payload.teamId,
            customFieldsValue: payload.customFieldsValues,
            ...payload.dispatchData
          }).then(() => {
            this.$store.dispatch('currentTournament/triggerLoading', false);
          });
        } else {
          this.$store.dispatch(payload.action, {
            customFieldsValue: payload.customFieldsValues,
            ...payload.dispatchData
          }).then(() => {
            this.$store.dispatch('currentTournament/triggerLoading', false);
          });
        }
      } else {
        if (payload && payload.teamId) {
          this.$store.dispatch('subTournaments/registerTeamIn', {
            teamId: payload.teamId,
            ...payload.dispatchData
          }).then(() => {
            this.$store.dispatch('currentTournament/triggerLoading', false);
          });
        } else {
          if (payload.dispatchData) {
            this.$store.dispatch(payload.action, payload.dispatchData)
                .then(() => {
                  this.$store.dispatch('currentTournament/triggerLoading', false);
                });
          } else {
            this.$store.dispatch(payload.action).then(() => {
              this.$store.dispatch('currentTournament/triggerLoading', false);
            });
          }
        }
      }
    },
    abortAction() {
      this.showPopUp = false;
      this.$store.dispatch('currentTournament/triggerLoading', false);
    },
    initPopUp(options) {
      this.popUpOptions = options;
      this.showPopUp = true;
    },
  },
  mounted(){
    /*this.$root.$on("init-pop-up", (data) => {
     this.initPopUp(data);
    });*/
  }
}
</script>

<template>
  <div class="container">
    <div class="about-desc my-5">
      <p class="m-0 p-0 text-white text-justify">
        Drop in, gear up, and survive the chaos in FreeFire’s fast-paced showdowns!
        Every second counts as you battle to be the last one standing.
        Bring your A-game and secure your slice of the 200.000 MAD prize pool!
      </p>
    </div>
    <div class="timeline-container my-5">
      <TimeLine steps-key="free-fire"/>
    </div>
    <div class="quali-tournaments-section w-100 my-5 pt-5">
      <SectionTitle subtitle="Registration" title="register<br>now"/>
      <div>
        <p class="qualifiers-text text-white text-justify w-100">
          No worries! You’ll have another chance to qualify. Once registration opens, you can sign up for the next-stage qualifiers if you didn’t make it through the previous stage.
        </p>
      </div>
      <div class="row no-gutters">
        <div class="col-12 col-md-6 col-lg-4 p-1"  v-for="(tournament,i) in tournaments_qualis" :key="i">
          <TournamentQualifierCard
              :banner="require('@/assets/imgs/2025/cards-bg/freefire-card.png')"
              :title="`Qualifier ${i}<br>tournament`"
              :tournament="+tournament"
              @init-pop-up="initPopUp"
          />
        </div>
      </div>
    </div>
    <div class="row my-5 pt-5">
      <div class="col-12 col-lg-6">
        <SectionTitle subtitle="prizes" title="Tournament<br>prize<br>pool" class="m-0 p-0"/>
      </div>
      <div class="col-12 col-lg-6 pt-lg-4">
        <PrizePool game="freefire"/>
      </div>
    </div>
    <LgameParticipatePopUp :pop-up-type="popUpOptions.type"
                           :title="popUpOptions.title"
                           :pop-up-message-body="popUpOptions.message"
                           :with-options="popUpOptions.withOptions"
                           :options="popUpOptions.options"
                           :dispatch-data="popUpOptions.action.payload"
                           :pop-up-dispatch="popUpOptions.action.action"
                           v-if="showPopUp"
                           @modal-closed="abortAction"
                           @acceptAction="acceptAction"
                           @abortAction="abortAction">
    </LgameParticipatePopUp>

  </div>
</template>

<style scoped>
.about-desc {
  font-family: "sqwaredregular";
}
</style>